import React from "react";
import EstadoDeCuentaTemplate from "../../components/templates/clientes/EstadoDeCuentaTemplate";

const EstadoDeCuenta = () => {
    return <EstadoDeCuentaTemplate/>
};

export default EstadoDeCuenta;